import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent } from "@/components/ui/drawer";

interface NavigationConfirmBottomSheetProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const NavigationConfirmBottomSheet = ({ isOpen, onConfirm, onCancel }: NavigationConfirmBottomSheetProps) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && handleCancel()} repositionInputs={false}>
      <DrawerContent
        className="mx-auto flex flex-col justify-center md:w-2/3 lg:w-1/2 border-none"
        dragClassName="h-1 mb-4 bg-disabled/70"
      >
        <div className="flex flex-col justify-center w-full border-none px-[32px]">
          <div className="animate-in fade-in zoom-in-95 duration-300 ease-out pb-[31px]">
            <div className="text-center mt-[13px]">
              <h2 className="font-bold text-black">コメントを削除しますか？</h2>
              <p className="text-dark-gray font-medium text-[14px] leading-[1.4] mt-[20px]">
                作成した内容は保存されません。
              </p>
            </div>

            <div className="flex flex-col gap-[24px] mt-[38px]">
              <PrimaryButton
                content="削除する"
                onClick={handleConfirm}
                className="w-full h-[48px] bg-gradient-primary"
              />

              <Button
                variant="ghost"
                className="text-[#176BF2] underline font-medium md:hover:bg-transparent p-0 h-[16px]"
                onClick={handleCancel}
              >
                閉じる
              </Button>
            </div>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
